<template>
  <AnnotationTag
    :recent-selected-tags="recentSelectedTags(LabelTaggingMode.ANNOTATION)"
    :selected-equipment-id="selectedEquipmentId"
    :collapse="collapse(LabelTaggingMode.ANNOTATION)"
    @onRecentTagSelected="handlePartIdSelected"
    @onToggleCollapse="handleToggleCollapse"
    @onCopyToClipboard="handleCopyToClipboard"
    @onPartIdSelected="handlePartIdSelected"
    @onNewPartClicked="handleNewPartClicked"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { LabelTaggingMode } from '@/utils';
import AnnotationTag from './AnnotationTag.vue';

export default {
  name: 'AnnotationTagContainer',
  components: {
    AnnotationTag,
  },
  props: {
    selectedPolygon: {
      type: Object,
      default: () => ({}),
    },
    displayName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      LabelTaggingMode,
      initialValue: null,
    };
  },
  computed: {
    ...mapGetters({
      inspectionDocument: 'inspectionDocument/currentInspectionInfo',
      selectedEquipmentId: 'spherical/selectedEquipmentId',
      recentSelectedTags: 'labelTagging/recentSelectedTags',
      collapse: 'labelTagging/collapse',
    }),
    data() {
      return [];
    },
  },
  methods: {
    ...mapActions({
      addToRecentSelectedTags: 'labelTagging/addToRecentSelectedTags',
      addSelectedAsset: 'spherical/addSelectedAsset',
      updateCurrentAssetParts: 'inspectionDocument/updateCurrentAssetParts',
      updateSelectedAnnotation: 'spherical/updateSelectedAnnotation',
      createPartInstance: 'spherical/createPartInstance',
      toggleCollapsed: 'labelTagging/toggleCollapsed',
      setNotification: 'spherical/setNotification',
    }),
    async handlePartIdSelected({ tagName }) {
      this.addToRecentSelectedTags({ taggingMode: LabelTaggingMode.ANNOTATION, tag: { tagName, tagId: tagName } });
      this.updateSelectedAnnotation({
        platformId: this.inspectionDocument._id,
        equipmentId: tagName,
        imageId: this.$route.query.image,
        annotationId: this.selectedPolygon.annotationId,
      });
    },
    handleToggleCollapse() {
      this.toggleCollapsed(LabelTaggingMode.ANNOTATION);
    },
    handleCopyToClipboard() {
      this.setNotification('Copied part ID to clipboard.');
    },
    handleNewPartClicked() {
      this.createPartInstance({
        platformId: this.inspectionDocument._id,
        imageId: this.$route.query.image,
        annotationId: this.selectedPolygon.annotationId,
      });
    },
  },
};
</script>
